import * as actions from '../../state';
// eslint-disable-next-line import/no-cycle
import store from '../../store';

const connected = () => new Promise((resolve) => {
  const interval = setInterval(() => {
    const isConnected = actions.selectIsConnected(store.getState());
    if (isConnected !== null) {
      clearInterval(interval);
      resolve();
    }
  }, 200);
});

export default connected;
